module.exports = {"pt-BR":{"errors":{"invalid":"não é válido","missing":"não pode ficar em branco","taken":"já está em uso"}}}